import React, { useState, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { TRANSLATIONS } from '../../../translations';
import Typography, {
  TypographyStates,
  TypographyVariants,
  TypographyWeights,
} from '../../ui-components/Typography/Typography';
import BetaIcon, { IconSizes } from '../Icons/Icon';
import { useVoucherPreviewTemplate } from '../../hooks/useVoucherPreviewTemplate';
import { useMatchesMinWidth } from '../../hooks/useMatchesMinWidth';
import { BREAKPOINTS } from '../../../constants';

const VoucherPreview = (props) => {
  const { name = '', message = '', listingId, seats = [], productId } = props;
  const voucherTemplate = useVoucherPreviewTemplate(
    listingId,
    name,
    message,
    seats,
    productId
  );
  const isDeviceSmallerThanTablet = !useMatchesMinWidth(BREAKPOINTS.TABLET);
  const isCheckout = window.location.pathname === '/checkout/';

  const iframeWidth = 792;
  const iframeHeight = 1123;
  const [scaleFactor, setScaleFactor] = useState(1);

  const calculateScaleFactor = () => {
    const container = document.getElementById('iframeContainer');
    const iframe = document.getElementById('voucherIframe');

    if (container && iframe) {
      const containerWidth = container.offsetWidth;
      const containerHeight = container.offsetHeight;

      const scaleFactor = Math.min(
        containerWidth / iframeWidth,
        containerHeight / iframeHeight
      );

      setScaleFactor(scaleFactor);
    }
  };

  useEffect(() => {
    calculateScaleFactor();
    window.addEventListener('resize', calculateScaleFactor);

    return () => {
      window.removeEventListener('resize', calculateScaleFactor);
    };
  }, []);

  const template = (
    <div className="p-xs w-100%">
      <span className="voucher-durationvoucher-preview d-flex gap-base items-start">
        <BetaIcon name={'info'} size={IconSizes[20]} />
        <span style={{ paddingTop: '2px' }}>
          <Typography
            classNames={'text-left'}
            variant={TypographyVariants.p3}
            state={TypographyStates.neutral}
          >
            {isCheckout
              ? TRANSLATIONS.VOUCHER_HINT_2
              : TRANSLATIONS.VOUCHER_HINT}
          </Typography>
        </span>
      </span>
      <div className="d-flex justify-center p-0">
        <div className="d-flex justify-center mt-s mb-s w-100%">
          {voucherTemplate && (
            <div
              id="iframeContainer"
              className="shadow-s"
              style={{
                width: isDeviceSmallerThanTablet
                  ? '100%'
                  : `${iframeWidth * scaleFactor}px`,
                height: isDeviceSmallerThanTablet
                  ? `${iframeHeight * scaleFactor}px`
                  : '580px',

                position: 'relative',
                overflow: 'hidden',
                border: '1px solid #e5e9ee',
              }}
            >
              <iframe
                id="voucherIframe"
                title="Voucher Preview"
                sandbox="allow-same-origin"
                srcDoc={voucherTemplate}
                style={{
                  width: iframeWidth,
                  height: iframeHeight,
                  transform: `scale(${scaleFactor})`,
                  transformOrigin: 'top left',
                  border: 'none',
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return voucherTemplate ? template : null;
};

VoucherPreview.propTypes = {
  name: PropTypes.string,
  message: PropTypes.string,
  listingId: PropTypes.string.isRequired,
  className: PropTypes.string,
  withMarginBottom: PropTypes.bool,
  productId: PropTypes.number,
};

VoucherPreview.defaultProps = {
  withMarginBottom: false,
  name: '',
  message: '',
};

export { VoucherPreview };
